import React from 'react'
import { Section, Loading } from 'components'
import UserResponsesManagerService from 'smart-components/user-responses-manager/Service'
import { useServiceState } from 'helpers'

const AsyncResponsesLoading: React.FC = (props: any) => {
  const userResponseManagerState = useServiceState(UserResponsesManagerService, false)

  return userResponseManagerState.isLoadingResponses ? (
    <Section padding={'250px 10px'} direction={'column'}>
      <Loading />
    </Section>
  ) : (
    props.children
  )
}

export default AsyncResponsesLoading
